import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';
import './TermsAndPrivacy.css';

const TermsOfService = () => {
    return (
        <div className="terms-privacy-container">
            <h1>Terms of Service</h1>

            <div className="terms-privacy-content">
                <p>Last Updated: January 21, 2026</p>

                <h2>1. USER ACCOUNTS</h2>
                <p>Users must provide accurate information. Students must be affiliated with a recognized institution. Professors must pass the mandatory vetting process to offer sessions.</p>

                <h2>2. THE ESCROW SYSTEM</h2>
                <p>EdVergenceX utilizes an Escrow model for all paid sessions.</p>
                <ul>
                    <li>Funds are collected from the Student at the time of a "Session Request."</li>
                    <li>Funds are held by the Platform until the session is marked as "Completed."</li>
                    <li>Upon completion, funds (minus platform fees) are released to the Professor.</li>
                </ul>

                <h2>3. ACADEMIC INTEGRITY</h2>
                <p>The platform is for mentorship and professional development. Users are prohibited from using the platform for cheating, completing graded assignments for others, or any form of academic dishonesty.</p>

                <h2>4. PLATFORM FEES</h2>
                <p>EdVergenceX reserves the right to charge a service fee on transactions. These fees are disclosed at the time of payment.</p>

                <h2>5. ACCOUNT DEACTIVATION</h2>
                <p>Users may request deactivation via the "Account" settings. EdVergenceX retains certain transaction and compliance data as required by law.</p>



                <div className="back-button-container">
                    <Link to="/" className="back-button">
                        <FaArrowLeft style={{ marginRight: '8px' }} /> Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;


